module.exports = __webpack_public_path__ + "static/img/38801v.246a2d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/38801v.jpg
// module id = XQhB
// module chunks = 1